import { Subscription } from 'rxjs';

export interface UploaderOptions {
  concurrency?: number;
  allowedContentTypes?: Array<string>;
  maxUploads?: number;
  maxFileSize?: number;
}

export interface BlobFile extends Blob {
  name: string;
}

/* eslint-disable @typescript-eslint/naming-convention */
// eslint-disable-next-line no-shadow
export enum UploadStatus {
  Queue,
  Uploading,
  Done,
  Cancelled,
  Rejected
}

// eslint-disable-next-line no-shadow
export enum UploadInputType {
  UPLOAD_ALL = 'uploadAll',
  UPLOAD_FILE = 'uploadFile',
  CANCEL = 'cancel',
  CANCEL_ALL = 'cancelAll',
  REMOVE = 'remove',
  REMOVE_ALL = 'removeAll'
}
/* eslint-enable @typescript-eslint/naming-convention */

export interface UploadProgress {
  status: UploadStatus;
  data?: {
    percentage: number;
    speed: number;
    speedHuman: string;
    startTime: number | null;
    endTime: number | null;
    eta: number | null;
    etaHuman: string | null;
  };
}

export interface UploadFile {
  id: string;
  fileIndex: number;
  lastModifiedDate: Date;
  name: string;
  size: number;
  type: string;
  form: FormData;
  progress: UploadProgress;
  response?: any;
  responseStatus?: number;
  sub?: Subscription | any;
  nativeFile?: File;
  responseHeaders?: { [key: string]: string };
}

export interface UploadOutput {
  type:
    | 'addedToQueue'
    | 'allAddedToQueue'
    | 'uploading'
    | 'done'
    | 'start'
    | 'cancelled'
    | 'dragOver'
    | 'dragOut'
    | 'drop'
    | 'removed'
    | 'removedAll'
    | 'rejected';
  file?: UploadFile;
  nativeFile?: File;
  totalProcessing?: number;
}
export interface UploadInput {
  type: UploadInputType | string;
  url?: string;
  method?: string;
  id?: string;
  fieldName?: string;
  fileIndex?: number;
  file?: UploadFile;
  data?: { [key: string]: string | Blob };
  headers?: { [key: string]: string };
  includeWebKitFormBoundary?: boolean; // If false, only the file is send trough xhr.send (WebKitFormBoundary is omit)
  withCredentials?: boolean;
}
// s3 metadata interface
export interface S3FileMetaData {
  [key: string]: string;
}

export const MAX_FILE_SIZE = 20 * 1024 * 1024; // 20MB - BE has hard limit of 20MB file size

export enum FileOutputTypeStatus {
  ADDED_TO_QUEUE = 'addedToQueue',
  ALL_ADDED_TO_QUEUE = 'allAddedToQueue',
  UPLOADING = 'uploading',
  DONE = 'done',
  START = 'start',
  CANCELLED = 'cancelled',
  DRAG_OVER = 'dragOver',
  DRAG_OUT = 'dragOut',
  DROP = 'drop',
  REMOVED = 'removed',
  REMOVED_ALL = 'removedAll',
  REJECTED = 'rejected'
}
